// import React, {Component} from 'react';
// import SideMenu from '../admin/SideMenu';
// import TopMenu from '../admin/TopBar';
// import {appDatabasePrimaryFunctions} from '../../base';
// import {convertTimeStampToHumanReadable, getURLParameter} from "../utils/HelpfulFunction";
// import {Toast, ErrorMessage, WarningMessage} from '../utils/HelpfulFunction';
// import {Navigate} from "react-router-dom";
//
// class UserInfo extends Component {
//     constructor(props) {
//         super(props);
//         const uid = getURLParameter("uid");
//         const playerPickEnabled = process.env.REACT_APP_HAS_PLAYER_PICK === "true";
//         const checkInEnabled = process.env.REACT_APP_HAS_CHECK_IN === "true";
//         const prizesEnabled = process.env.REACT_APP_HAS_PRIZES === "true";
//         const badgesEnabled = process.env.REACT_APP_HAS_BADGES === "true";
//         this.state = {
//             uid: uid,
//             loading: true,
//             badgesEnabled,
//             prizesEnabled,
//             checkInEnabled,
//             playerPickEnabled
//         };
//         this.handleChange = this.handleChange.bind(this);
//     }
//
//     async componentDidMount() {
//         this.loadUserData();
//         const getAdminToken = await this.props.userData.getIdToken();
//         this.setState({
//             token: getAdminToken
//         })
//     }
//
//     async loadUserData(){
//         const uid = this.state.uid;
//         const uidToUsernameRef = await appDatabasePrimaryFunctions.ref(`uidToUsername/${uid}`).once('value');
//         const uidToUsername = uidToUsernameRef.val() || {};
//         const userName = uidToUsername.userName;
//         let promises = [];
//         let definitionsOfPromises = [];
//         let promisesRun;
//         if(userName){
//             const userRef = appDatabasePrimaryFunctions.ref(`users/${uid}`).once('value');
//             promises.push(userRef);
//             definitionsOfPromises.push('users')
//             const userLevelRef = appDatabasePrimaryFunctions.ref(`userLevel/${uid}`).once('value');
//             const userPointsRef = appDatabasePrimaryFunctions.ref(`userPoints/${uid}`).once('value');
//             if(this.state.badgesEnabled || this.state.checkInEnabled || this.state.playerPickEnabled){
//                 promises.push(userLevelRef, userPointsRef)
//                 definitionsOfPromises.push('level', 'points')
//             }
//             const userHistoryRef = appDatabasePrimaryFunctions.ref(`userHistory/${userName}`).once('value');
//             if(this.state.checkInEnabled){
//                 promises.push(userHistoryRef);
//                 definitionsOfPromises.push('checkIns')
//             }
//             const uniqueRewardUrl = process.env.REACT_APP_REWARD_URL + `redeemed_coupons/user/${uid}`;
//             if(this.state.prizesEnabled){
//                 promises.push(uniqueRewardUrl);
//                 definitionsOfPromises.push('rewards')
//             }
//             const userBadgesRef = appDatabasePrimaryFunctions.ref(`userBadges/${uid}`).once('value');
//             if(this.state.badgesEnabled){
//                 promises.push(userBadgesRef)
//                 definitionsOfPromises.push('badges')
//             }
//             const couponEmailRef = appDatabasePrimaryFunctions.ref(`couponEmail/${uid}`).once('value');
//             const userNameToEmailRef = appDatabasePrimaryFunctions.ref(`usernameToEmail/${userName}`).once('value');
//             promises.push(couponEmailRef, userNameToEmailRef);
//             definitionsOfPromises.push('couponEmail', 'userNameToEmail');
//             promisesRun = await Promise.all(promises);
//         } else {
//             this.setState({
//                 loading: false,
//                 redirect: true
//             })
//             return;
//         }
//         let user = {};
//         let userLevel = {};
//         let userPoints = {};
//         let userRewards = {};
//         let userBadges = {};
//         let couponEmail = "";
//         let userNameToEmail = {};
//         let userHistory = {};
//         for(const i in promisesRun){
//             let promise = promisesRun[i];
//             let promiseName = definitionsOfPromises[i];
//             if(promiseName === "users"){
//                 user = promise.val() || {};
//             } else if(promiseName === "level"){
//                 userLevel = promise.val() || {};
//             } else if(promiseName === "points"){
//                 userPoints = promise.val() || {};
//             } else if(promiseName === "checkIns"){
//                 userHistory = promise.val() || {};
//             } else if(promiseName === "rewards"){
//                 userRewards = promiseName || {};
//             } else if(promiseName === "badges"){
//                 userBadges = promise.val() || {};
//             } else if(promiseName === "couponEmail"){
//                 couponEmail = promise.val() || "";
//             } else if(promiseName === "userNameToEmail"){
//                 userNameToEmail = promise.val() || {};
//             } else {
//                 console.log("NOT FOUND")
//             }
//         }
//         const rewardsRedeemedCount = userRewards.data ? userRewards.data.length : 0;
//         const email = user.email || userNameToEmail.email ||couponEmail || "";
//         const signUpTime = user.signUpTime;
//         const totalPoints = userLevel.totalPoints || 0;
//         const currentPoints = userPoints.points || 0;
//         const checkIns = userHistory.checkIns || {};
//         const checkInsCount = Object.keys(checkIns).length;
//         const numberOfBadges = Object.keys(userBadges).length;
//         this.setState({
//             loading: false,
//             checkInsCount: checkInsCount,
//             currentPoints: currentPoints,
//             totalPoints: totalPoints,
//             signUpTime: signUpTime,
//             email: email,
//             userName: userName,
//             rewardsRedeemedCount: rewardsRedeemedCount,
//             numberOfBadges: numberOfBadges
//         })
//     }
//
//     handleChange (evt) {
//         let target = evt.target;
//         let value = target.type === 'checkbox' ? target.checked : target.value;
//         this.setState({ [evt.target.name]: value });
//     }
//
//     async deleteUser(){
//         const result = await WarningMessage.fire({
//             title: 'STOP!',
//             text: 'Are you sure you want to do this?  This will erase all information about this user.  If you do this the data will be IRRETRIEVABLE.',
//             confirmButtonText: 'YES I WANT TO PERMANENTLY DELETE THIS DATA'
//         })
//         if(!result || !result.value) return;
//         const userResponse = {};
//         userResponse['uidToDelete'] = this.state.uid;
//         let url = `https://us-central1-${process.env.REACT_APP_FIREBASE_PROJECT_ID}.cloudfunctions.net/api/deleteUser`;
//         if(process.env.NODE_ENV === "development"){
//             url = `http://localhost:5001/${process.env.REACT_APP_FIREBASE_PROJECT_ID}/us-central1/api/deleteUser`;
//         }
//         this.setState({loading:true})
//         fetch(url, {
//             method: 'POST',
//             headers: {
//                 'Content-Type': 'application/json',
//                 'Authorization':`Bearer ${this.state.token}`
//             },
//             body: JSON.stringify(userResponse),
//         }).then(res => {
//             this.setState({loading:false})
//             const vm = this;
//             Promise.resolve(res.json()).then(function (value) {
//                 if(!value || value.message === "Invalid Permissions") {
//                     ErrorMessage.fire({
//                         title: 'Oh uh!',
//                         text: 'Auth or request error; logout and log back in',
//                     })
//                     return;
//                 } else if(value.message === "auth/user-not-found - There is no user record corresponding to the provided identifier.") {
//                     ErrorMessage.fire({
//                         title: 'Oh uh!',
//                         text: 'User not found, check your internet connection and try again.  If the problem continues reach out to Sqwad.',
//                     })
//                     return;
//                 }
//                 vm.setState({
//                     redirect: true
//                 })
//                 Toast.fire({
//                     title: 'User Deleted'
//                 })
//             })
//         }).catch(err => {
//             ErrorMessage.fire({
//                 title: 'Oh uh!',
//                 text: 'Auth or request error; logout and log back in',
//             })
//             this.setState({loading: false});
//         })
//     }
//
//     render() {
//         const {loading, email="", checkInsCount=0, currentPoints=0, totalPoints=0, signUpTime=0, userName="", rewardsRedeemedCount=0, numberOfBadges=0, redirect=false, playerPickEnabled=false, checkInEnabled=false,prizesEnabled=false,badgesEnabled=false} = this.state;
//         if(redirect === true){
//             return <Navigate to="/usermanagement" />
//         }
//         return (
//           <div className="admin-wrapper">
//             <div className="loading-screen" style={{display: loading ? 'block' : 'none' }}/>
//             <SideMenu/>
//             <TopMenu/>
//             <div className="admin-main-panel">
//                 <div className="container" style={{color: "black", padding:20}}>
//                     <div className="row" style={{margin: 20}}>
//                         <div className="col" style={{textAlign:"center"}}>
//                             <p style={{fontSize: 40}}>User Info</p>
//                         </div>
//                     </div>
//                     <div className="row">
//                         <div className="col">
//                             <p>
//                                 Username: {userName}
//                             </p>
//                             <p>
//                                 Email: {email || "None Found"}
//                             </p>
//                             <p>
//                                 Signed Up: {signUpTime ? convertTimeStampToHumanReadable(signUpTime) : "None Detected"}
//                             </p>
//                         </div>
//                     </div>
//                     <div className="row">
//                         {checkInEnabled &&
//                             <div className="col-4">
//                                 <p>
//                                     Check Ins: {checkInsCount}
//                                 </p>
//                             </div>
//                         }
//                         {(playerPickEnabled || checkInEnabled || badgesEnabled) &&
//                             <div className="col-4">
//                                 <p>
//                                     Total Points: {totalPoints}
//                                 </p>
//                             </div>
//                         }
//                         {(playerPickEnabled || checkInEnabled || badgesEnabled) &&
//                             <div className="col-4">
//                                 <p>
//                                     Available Points: {currentPoints}
//                                 </p>
//                             </div>
//                         }
//                     </div>
//                     <div className="row">
//                         {prizesEnabled &&
//                             <div className="col-4">
//                                 <p>
//                                     Prizes Redeemed: {rewardsRedeemedCount}
//                                 </p>
//                             </div>
//                         }
//                         {badgesEnabled &&
//                             <div className="col-4">
//                                 <p>
//                                     Badges Received: {numberOfBadges}
//                                 </p>
//                             </div>
//                         }
//                     </div>
//                     <div className="row">
//                         <div className="col">
//                             <div className="form-check">
//                                 <label className="form-check-label" htmlFor="advanced">Advanced</label>
//                                 <input value={this.state.advanced} className="form-check-input" id="advanced" name="advanced" type="checkbox" checked={this.state.advanced} onChange={this.handleChange} />
//                             </div>
//                         </div>
//                     </div>
//                     {this.state.advanced &&
//                         <div className="row">
//                             <div className="col" style={{textAlign: "center"}}>
//                                 <button className="btn btn-danger" onClick={()=>this.deleteUser()}>
//                                     <span className="fa fa-trash pre_side_item"/> Permanently Delete User
//                                 </button>
//                             </div>
//                         </div>
//                     }
//                 </div>
//             </div>
//          </div>
//         );
//     }
// }
//
// export default UserInfo


// File: src/components/admin/UserInfo.js

import React, { Component } from 'react';
import SideMenu from '../admin/SideMenu';
import TopMenu from '../admin/TopBar';
import { appDatabasePrimaryFunctions } from '../../base';
import {
    convertTimeStampToHumanReadable,
    getURLParameter,
    Toast,
    ErrorMessage,
    WarningMessage,
    readApiResponse
} from '../utils/HelpfulFunction';
import { Navigate } from 'react-router-dom';

// 1) Import your push-notification service function
import { sendImmediateNotificationToTokens, getPushTokensForUser } from '../services/pushNotificationService';
import { teamIdOptions } from '../utils/experienceScope';

// API URL for Firebase Functions
let apiUrl = `https://us-central1-${process.env.REACT_APP_FIREBASE_PROJECT_ID}.cloudfunctions.net/api/`;
if (process.env.NODE_ENV === 'development') {
    apiUrl = `http://localhost:5001/${process.env.REACT_APP_FIREBASE_PROJECT_ID}/us-central1/api/`;
}

class UserInfo extends Component {
    constructor(props) {
        super(props);
        const uid = getURLParameter('uid');
        const playerPickEnabled = process.env.REACT_APP_HAS_PLAYER_PICK === 'true';
        const checkInEnabled = process.env.REACT_APP_HAS_CHECK_IN === 'true';
        const prizesEnabled = process.env.REACT_APP_HAS_PRIZES === 'true';
        const badgesEnabled = process.env.REACT_APP_HAS_BADGES === 'true';

        this.state = {
            uid: uid,
            loading: true,
            badgesEnabled,
            prizesEnabled,
            checkInEnabled,
            playerPickEnabled,

            // FCM tokens for this user's registered devices (one per device).
            pushTokens: [],
            pushTitle: '',
            pushMessage: '',

            // Season-ticket entitlements for this user, keyed by teamId
            entitlements: {},
            teamExperiences: [],
            sthMeta: {},
            // Coded-offer codes this user is holding (via the admin endpoint —
            // offerAssignments is owner-read-only)
            offerCodes: [],

            // Advanced UI toggle
            advanced: false,
        };
        this.handleChange = this.handleChange.bind(this);
    }

    async componentDidMount() {
        this.loadUserData();
        this.loadEntitlements();
        const getAdminToken = await this.props.userData.getIdToken();
        this.setState({
            token: getAdminToken
        });
    }

    async loadUserData() {
        const uid = this.state.uid;
        const uidToUsernameRef = await appDatabasePrimaryFunctions
            .ref(`uidToUsername/${uid}`)
            .once('value');
        const uidToUsername = uidToUsernameRef.val() || {};
        const userName = uidToUsername.userName;

        if (!userName) {
            // If no user found, redirect
            this.setState({
                loading: false,
                redirect: true
            });
            return;
        }

        // Build a list of Firebase references to fetch
        const promises = [];
        const definitionsOfPromises = [];

        // Basic user data (including pushToken, if available)
        const userRef = appDatabasePrimaryFunctions.ref(`users/${uid}`).once('value');
        promises.push(userRef);
        definitionsOfPromises.push('users');

        // Conditional references
        const userLevelRef = appDatabasePrimaryFunctions.ref(`userLevel/${uid}`).once('value');
        const userPointsRef = appDatabasePrimaryFunctions.ref(`userPoints/${uid}`).once('value');
        if (this.state.badgesEnabled || this.state.checkInEnabled || this.state.playerPickEnabled) {
            promises.push(userLevelRef, userPointsRef);
            definitionsOfPromises.push('level', 'points');
        }

        const userHistoryRef = appDatabasePrimaryFunctions.ref(`userHistory/${userName}`).once('value');
        if (this.state.checkInEnabled) {
            promises.push(userHistoryRef);
            definitionsOfPromises.push('checkIns');
        }

        // For prizes
        const uniqueRewardUrl = process.env.REACT_APP_REWARD_URL + `redeemed_coupons/user/${uid}`;
        if (this.state.prizesEnabled) {
            // (In your original code, you used 'promises.push(uniqueRewardUrl)' but that’s a URL string,
            // you’d typically fetch that via fetch() if you have an API.)
            // Adjust if needed:
            promises.push(Promise.resolve({ data: [] })); // placeholder
            definitionsOfPromises.push('rewards');
        }

        // For badges
        const userBadgesRef = appDatabasePrimaryFunctions.ref(`userBadges/${uid}`).once('value');
        if (this.state.badgesEnabled) {
            promises.push(userBadgesRef);
            definitionsOfPromises.push('badges');
        }

        const couponEmailRef = appDatabasePrimaryFunctions.ref(`couponEmail/${uid}`).once('value');
        const userNameToEmailRef = appDatabasePrimaryFunctions.ref(`usernameToEmail/${userName}`).once('value');
        promises.push(couponEmailRef, userNameToEmailRef);
        definitionsOfPromises.push('couponEmail', 'userNameToEmail');

        // Resolve all data
        const promisesRun = await Promise.all(promises);

        // Parse data
        let user = {};
        let userLevel = {};
        let userPoints = {};
        let userRewards = {};
        let userBadges = {};
        let couponEmail = '';
        let userNameToEmail = {};
        let userHistory = {};

        for (let i = 0; i < promisesRun.length; i++) {
            const promiseResult = promisesRun[i];
            const promiseName = definitionsOfPromises[i];

            if (promiseName === 'users') {
                user = promiseResult.val() || {};
            } else if (promiseName === 'level') {
                userLevel = promiseResult.val() || {};
            } else if (promiseName === 'points') {
                userPoints = promiseResult.val() || {};
            } else if (promiseName === 'checkIns') {
                userHistory = promiseResult.val() || {};
            } else if (promiseName === 'rewards') {
                // In the original code, `userRewards = promiseName || {};`
                // That looks like a bug. We'll do:
                userRewards = promiseResult || {};
            } else if (promiseName === 'badges') {
                userBadges = promiseResult.val() || {};
            } else if (promiseName === 'couponEmail') {
                couponEmail = promiseResult.val() || '';
            } else if (promiseName === 'userNameToEmail') {
                userNameToEmail = promiseResult.val() || {};
            } else {
                console.log('NOT FOUND');
            }
        }

        const rewardsRedeemedCount = userRewards.data ? userRewards.data.length : 0;
        const email = user.email || userNameToEmail.email || couponEmail || '';
        const signUpTime = user.signUpTime;
        const totalPoints = userLevel.totalPoints || 0;
        const currentPoints = userPoints.points || 0;
        const checkIns = userHistory.checkIns || {};
        const checkInsCount = Object.keys(checkIns).length;
        const numberOfBadges = Object.keys(userBadges).length;
        const pushTokens = await getPushTokensForUser(user.uid);

        this.setState({
            loading: false,
            checkInsCount: checkInsCount,
            currentPoints: currentPoints,
            totalPoints: totalPoints,
            signUpTime: signUpTime,
            email: email,
            userName: userName,
            rewardsRedeemedCount: rewardsRedeemedCount,
            numberOfBadges: numberOfBadges,
            pushTokens: pushTokens
        });
    }

    handleChange(evt) {
        const target = evt.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        this.setState({ [target.name]: value });
    }

    /**
     * Delete the user (existing logic).
     */
    async deleteUser() {
        const result = await WarningMessage.fire({
            title: 'STOP!',
            text: 'Are you sure you want to do this? This will erase all information about this user. This data will be IRRETRIEVABLE.',
            confirmButtonText: 'YES I WANT TO PERMANENTLY DELETE THIS DATA'
        });
        if (!result || !result.value) return;

        const userResponse = { uidToDelete: this.state.uid };
        let url = `https://us-central1-${process.env.REACT_APP_FIREBASE_PROJECT_ID}.cloudfunctions.net/api/deleteUser`;
        if (process.env.NODE_ENV === 'development') {
            url = `http://localhost:5001/${process.env.REACT_APP_FIREBASE_PROJECT_ID}/us-central1/api/deleteUser`;
        }

        this.setState({ loading: true });
        try {
            const res = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${this.state.token}`
                },
                body: JSON.stringify(userResponse)
            });
            this.setState({ loading: false });

            const value = await res.json();
            if (!value || value.message === 'Invalid Permissions') {
                await ErrorMessage.fire({
                    title: 'Oh uh!',
                    text: 'Auth or request error; logout and log back in'
                });
                return;
            } else if (value.message === 'auth/user-not-found - There is no user record corresponding to the provided identifier.') {
                await ErrorMessage.fire({
                    title: 'Oh uh!',
                    text: 'User not found, check your internet connection and try again. If the problem continues reach out to Sqwad.'
                });
                return;
            }

            // success
            this.setState({ redirect: true });
            await Toast.fire({
                title: 'User Deleted'
            });
        } catch (err) {
            console.error(err);
            await ErrorMessage.fire({
                title: 'Oh uh!',
                text: 'Auth or request error; logout and log back in'
            });
            this.setState({ loading: false });
        }
    }

    /**
     * Load this user's season-ticket entitlements plus the team experiences
     * and roster meta (label/season end) used for manual grants.
     */
    async loadEntitlements() {
        const uid = this.state.uid;
        try {
            const [entitlementsSnap, experiencesSnap] = await Promise.all([
                appDatabasePrimaryFunctions.ref(`entitlements/${uid}`).once('value'),
                appDatabasePrimaryFunctions.ref('experiences').once('value')
            ]);
            const entitlements = entitlementsSnap.val() || {};
            const experiences = experiencesSnap.val() || {};
            // Grant/revoke is keyed on a teamId, not on an experience. A club
            // with none still has season ticket members, so it gets one option
            // standing for itself — otherwise entitlementRows came back empty
            // and the whole Season Ticket Status block silently did not render,
            // leaving revoke reachable (via orphans) but grant impossible.
            const teamExperiences = teamIdOptions(experiences);
            const metaSnaps = await Promise.all(
                teamExperiences.map(exp =>
                    appDatabasePrimaryFunctions.ref(`sthRoster/${exp.id}/meta`).once('value')
                )
            );
            const sthMeta = {};
            teamExperiences.forEach((exp, index) => {
                if (metaSnaps[index].exists()) {
                    sthMeta[exp.id] = metaSnaps[index].val();
                }
            });
            this.setState({ entitlements, teamExperiences, sthMeta });
        } catch (err) {
            console.error('Error loading entitlements:', err);
        }
        await this.loadOfferCodes();
    }

    /**
     * Codes this user is holding. offerAssignments is owner-read-only in the
     * rules, so this goes through the admin endpoint rather than reading RTDB.
     */
    async loadOfferCodes() {
        const uid = this.state.uid;
        try {
            const token = this.props.userData ? await this.props.userData.getIdToken() : null;
            if (!token) return;
            const response = await fetch(`${apiUrl}offerAssignmentsForUser?uid=${encodeURIComponent(uid)}`, {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            const { ok, data } = await readApiResponse(response);
            if (ok) this.setState({ offerCodes: data.assignments || [] });
        } catch (err) {
            console.error('Error loading offer codes:', err);
        }
    }

    /**
     * Manually grant or revoke this user's season-ticket status for a team.
     */
    async setEntitlement(teamId, grant, teamName) {
        if (!grant) {
            const result = await WarningMessage.fire({
                title: 'Revoke season ticket status?',
                text: `This immediately removes the ${teamName || teamId} season ticket status from this user.`,
                confirmButtonText: 'Revoke'
            });
            if (!result || !result.value) return;
        }

        // Fresh token per call — the one cached at mount expires after ~an hour
        let token = null;
        try {
            token = this.props.userData ? await this.props.userData.getIdToken() : null;
        } catch (err) {
            console.error('Error refreshing auth token:', err);
        }
        if (!token) {
            await ErrorMessage.fire({
                title: 'Not authenticated',
                text: 'Could not get an auth token, refresh the page and try again.'
            });
            return;
        }

        // Manual grants reuse the team's roster meta (label + season end) when present
        const meta = this.state.sthMeta[teamId] || {};
        this.setState({ loading: true });
        try {
            const res = await fetch(apiUrl + 'setEntitlement', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`
                },
                body: JSON.stringify({
                    uid: this.state.uid,
                    teamId: teamId,
                    grant: grant,
                    label: meta.label || 'Season Ticket Member',
                    expiresAt: meta.expiresAt || null
                })
            });
            const data = await res.json();
            this.setState({ loading: false });
            if (res.ok) {
                Toast.fire({ title: grant ? 'Status granted' : 'Status revoked' });
                await this.loadEntitlements();
            } else {
                await ErrorMessage.fire({
                    title: 'Update failed',
                    text: data.error || 'Something went wrong updating the status.'
                });
            }
        } catch (err) {
            console.error(err);
            await ErrorMessage.fire({
                title: 'Update failed',
                text: 'Something went wrong updating the status, check your connection and try again.'
            });
            this.setState({ loading: false });
        }
    }

    /**
     * Send a push message to every device registered to this user.
     */
    async sendPushToUser() {
        const { pushTokens = [], pushTitle, pushMessage, userName } = this.state;
        if (!pushTokens.length) {
            await ErrorMessage.fire({
                title: 'No Push Token',
                text: `User "${userName}" has no registered devices.`
            });
            return;
        }
        if (!pushMessage.trim()) {
            await ErrorMessage.fire({
                title: 'No Message',
                text: 'Please enter a push message before sending.'
            });
            return;
        }

        try {
            await sendImmediateNotificationToTokens(
                pushTokens,
                pushTitle,
                pushMessage
            );
        } catch (err) {
            console.error(err);
        }
    }

    render() {
        const {
            loading,
            email = '',
            checkInsCount = 0,
            currentPoints = 0,
            totalPoints = 0,
            signUpTime = 0,
            userName = '',
            rewardsRedeemedCount = 0,
            numberOfBadges = 0,
            redirect = false,
            playerPickEnabled = false,
            checkInEnabled = false,
            prizesEnabled = false,
            badgesEnabled = false,

            // For sending push messages
            pushTitle,
            pushMessage,

            // Season-ticket entitlements
            entitlements = {},
            teamExperiences = [],
            offerCodes = [],

            advanced
        } = this.state;

        // Every team experience plus any entitlement for a team that no
        // longer exists as an experience (so it can still be revoked)
        const entitlementRows = teamExperiences
            .map(exp => ({ teamId: exp.id, teamName: exp.name, entitlement: entitlements[exp.id] || null }))
            .concat(
                Object.keys(entitlements)
                    .filter(teamId => !teamExperiences.some(exp => exp.id === teamId))
                    .map(teamId => ({ teamId, teamName: teamId, entitlement: entitlements[teamId] }))
            );

        if (redirect) {
            return <Navigate to="/usermanagement" />;
        }

        return (
            <div className="admin-wrapper">
                <div className="loading-screen" style={{ display: loading ? 'block' : 'none' }} />
                <SideMenu />
                <TopMenu />
                <div className="admin-main-panel">
                    <div className="container" style={{ padding: 20 }}>
                        {/* was a centred 40px <p> acting as the page title */}
                        <div className="admin-page-head" style={{ margin: '0 0 18px' }}>
                            <p className="admin-eyebrow">Access</p>
                            <p className="admin-header-text">User Info</p>
                            <p className="admin-page-sub">Everything this account has done in the app.</p>
                        </div>
                        <div className="row">
                            <div className="col">
                                <p>Username: {userName}</p>
                                <p>Email: {email || 'None Found'}</p>
                                <p>
                                    Signed Up:{' '}
                                    {signUpTime ? convertTimeStampToHumanReadable(signUpTime) : 'None Detected'}
                                </p>
                            </div>
                        </div>

                        {/* Extra Stats */}
                        <div className="row">
                            {checkInEnabled && (
                                <div className="col-4">
                                    <p>Check Ins: {checkInsCount}</p>
                                </div>
                            )}
                            {(playerPickEnabled || checkInEnabled || badgesEnabled) && (
                                <div className="col-4">
                                    <p>Total Points: {totalPoints}</p>
                                </div>
                            )}
                            {(playerPickEnabled || checkInEnabled || badgesEnabled) && (
                                <div className="col-4">
                                    <p>Available Points: {currentPoints}</p>
                                </div>
                            )}
                        </div>

                        <div className="row">
                            {prizesEnabled && (
                                <div className="col-4">
                                    <p>Rewards redeemed: {rewardsRedeemedCount}</p>
                                </div>
                            )}
                            {badgesEnabled && (
                                <div className="col-4">
                                    <p>Badges Received: {numberOfBadges}</p>
                                </div>
                            )}
                        </div>

                        {/* Season Ticket Status */}
                        {entitlementRows.length > 0 && (
                            <div className="row" style={{ marginTop: 30 }}>
                                <div className="col">
                                    <h4>Season Ticket Status</h4>
                                    <p style={{ fontSize: 12, fontWeight: 'normal', color: 'grey' }}>
                                        Statuses are normally earned by Ticketmaster verification against the team's roster;
                                        granting here bypasses that check.
                                    </p>
                                    <div className="admin-table-wrap">
                                        <table className="table">
                                            <thead>
                                                <tr>
                                                    <th>Team</th>
                                                    <th>Status</th>
                                                    <th>Source</th>
                                                    <th>Verified</th>
                                                    <th>Expires</th>
                                                    <th />
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {entitlementRows.map(row => (
                                                    <tr key={row.teamId}>
                                                        <td>{row.teamName}</td>
                                                        <td>{row.entitlement ? (row.entitlement.label || 'Season Ticket Member') : <span style={{ color: 'grey' }}>None</span>}</td>
                                                        <td>{row.entitlement ? (row.entitlement.source || '-') : '—'}</td>
                                                        <td>{row.entitlement && row.entitlement.verifiedAt ? convertTimeStampToHumanReadable(row.entitlement.verifiedAt) : '—'}</td>
                                                        <td>{row.entitlement && row.entitlement.expiresAt ? convertTimeStampToHumanReadable(row.entitlement.expiresAt) : '—'}</td>
                                                        <td>
                                                            {row.entitlement ? (
                                                                <button className="btn btn-danger btn-sm" onClick={() => this.setEntitlement(row.teamId, false, row.teamName)}>
                                                                    Revoke
                                                                </button>
                                                            ) : (
                                                                <button className="btn btn-primary btn-sm" onClick={() => this.setEntitlement(row.teamId, true, row.teamName)}>
                                                                    Grant
                                                                </button>
                                                            )}
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* Offer codes this user is holding — what support needs when
                            a code won't scan at the concession stand */}
                        {offerCodes.length > 0 && (
                            <div className="row" style={{ marginTop: 30 }}>
                                <div className="col">
                                    <h4>Offer Codes</h4>
                                    <p style={{ fontSize: 12, fontWeight: 'normal', color: 'grey' }}>
                                        Each code is permanent for this user — it never rotates, so this is exactly what
                                        their app is showing.
                                    </p>
                                    <div className="admin-table-wrap">
                                        <table className="table">
                                            <thead>
                                                <tr>
                                                    <th>Offer</th>
                                                    <th>Code</th>
                                                    <th>Claimed</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {offerCodes.map(assignment => (
                                                    <tr key={assignment.offerId}>
                                                        <td>{assignment.title}</td>
                                                        <td style={{ fontFamily: 'monospace', fontWeight: 'bold' }}>{assignment.code}</td>
                                                        <td>{assignment.assignedAt ? convertTimeStampToHumanReadable(assignment.assignedAt) : '—'}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* Toggle for advanced actions (e.g. delete user) */}
                        <div className="row">
                            <div className="col">
                                <div className="form-check">
                                    <label className="form-check-label" htmlFor="advanced">
                                        Advanced
                                    </label>
                                    <input
                                        value={advanced}
                                        className="form-check-input"
                                        id="advanced"
                                        name="advanced"
                                        type="checkbox"
                                        checked={advanced}
                                        onChange={this.handleChange}
                                    />
                                </div>
                            </div>
                        </div>

                        {/* Advanced controls */}
                        {advanced && (
                            <div className="row">
                                <div className="col" style={{ textAlign: 'center' }}>
                                    <button className="btn btn-danger" onClick={() => this.deleteUser()}>
                                        <span className="fa fa-trash pre_side_item" /> Permanently Delete User
                                    </button>
                                </div>
                            </div>
                        )}

                        {/* Send a direct push message to this user */}
                        {/*<div className="row" style={{ marginTop: 30 }}>*/}
                        {/*    <div className="col-12" style={{ textAlign: 'center' }}>*/}
                        {/*        <h4>Send a Push Notification to {userName}</h4>*/}
                        {/*    </div>*/}
                        {/*</div>*/}
                        {/*<div className="row" style={{ marginTop: 10 }}>*/}
                        {/*    <div className="col-md-6 offset-md-3">*/}
                        {/*        <div className="form-group">*/}
                        {/*            <label htmlFor="pushTitle">Title (optional):</label>*/}
                        {/*            <input*/}
                        {/*                type="text"*/}
                        {/*                className="form-control"*/}
                        {/*                id="pushTitle"*/}
                        {/*                name="pushTitle"*/}
                        {/*                value={pushTitle}*/}
                        {/*                onChange={this.handleChange}*/}
                        {/*                placeholder="e.g. Hello from Admin"*/}
                        {/*            />*/}
                        {/*        </div>*/}
                        {/*        <div className="form-group" style={{ marginTop: 10 }}>*/}
                        {/*            <label htmlFor="pushMessage">Message:</label>*/}
                        {/*            <textarea*/}
                        {/*                className="form-control"*/}
                        {/*                id="pushMessage"*/}
                        {/*                name="pushMessage"*/}
                        {/*                value={pushMessage}*/}
                        {/*                onChange={this.handleChange}*/}
                        {/*                placeholder="Enter your notification message here..."*/}
                        {/*                rows="3"*/}
                        {/*            />*/}
                        {/*        </div>*/}
                        {/*        <button*/}
                        {/*            className="btn btn-primary"*/}
                        {/*            style={{ marginTop: 10 }}*/}
                        {/*            onClick={() => this.sendPushToUser()}*/}
                        {/*        >*/}
                        {/*            Send Push Notification*/}
                        {/*        </button>*/}
                        {/*    </div>*/}
                        {/*</div>*/}
                    </div>
                </div>
            </div>
        );
    }
}

export default UserInfo;
